import type { FunctionComponent } from 'react'
import { createElement, Suspense } from 'react'
import type { RouteObject } from 'react-router-dom'
import { Navigate } from 'react-router-dom'
import { OmniaComponents, Services } from '../services/services'
import { PageWrapper } from './PageWrapper'

// eslint-disable-next-line complexity -- to be refactored at a later time
export const getRoutes = (overridePageComponent?: { pageKey: string; component: FunctionComponent }) => {
    const routes: RouteObject[] = []
    for (const page of Services.NavigationService.PagesNames(true)) {
        const overrideElement = page === overridePageComponent?.pageKey ? overridePageComponent.component : undefined

        /*
         * The "urls" property is undefined if a react router page does not have a corresponding umbraco page setup.
         * */
        if (Services.NavigationService.Pages[page].urls && Services.NavigationService.Pages[page].urls!.length) {
            const pageRoute: RouteObject = {
                element: <PageWrapper page={page} overrideElement={overrideElement} />,
            }

            let hasSubPages = false
            if (
                Services.NavigationService.Pages[page].subPages &&
                Services.NavigationService.Pages[page].subPages!.length > 0
            ) {
                hasSubPages = true
                pageRoute.children = []
                for (const subPage of Services.NavigationService.Pages[page].subPages!) {
                    const overrideSubPageComponent =
                        subPage.alias === overridePageComponent?.pageKey ? overridePageComponent?.component : undefined

                    if (subPage?.urls?.length) {
                        pageRoute.children.push({
                            element: (
                                <Suspense fallback={OmniaComponents.Loading ? <OmniaComponents.Loading /> : <></>}>
                                    {createElement(overrideSubPageComponent ?? subPage.component)}
                                </Suspense>
                            ),
                            path: subPage.urls[0].replace(Services.NavigationService.Pages[page].urls![0], ''),
                        })
                    }
                }

                // When no subpage was found, go to first one
                pageRoute.children.push({
                    element: <Navigate to={Services.NavigationService.Pages[page]?.subPages?.[0].urls?.[0] ?? '/'} />,
                    path: '*',
                })
            }

            for (const url of Services.NavigationService.Pages[page].urls!) {
                routes.push({ ...pageRoute, path: url + (hasSubPages ? '/*' : '') })
            }
        }
    }

    // Not found routes work as you'd expect
    routes.push({
        path: '*',
        element: <PageWrapper page={'ErrorNotFound'} />,
    })

    return routes
}
